<arpio-center-panel>
  <h3 class="panel-title">Oops...</h3>
  <ng-container *ngIf="errorDescription; else noDescriptionBlock">
    <div class="margin-top">{{ errorDescription }}</div>
  </ng-container>
  <ng-template #noDescriptionBlock>
    <div class="margin-top">An error occurred while processing your Azure Marketplace subscription request.</div>
  </ng-template>
  <div class="margin-top">
    Please go back to the Azure Marketplace and find {{ uiService.productName }} under "Your Products". You should then
    be able to navigate back here with a valid subscription.
  </div>
  <div class="margin-top">For additional help, contact {{ uiService.supportContact }}.</div>
</arpio-center-panel>
